import { Component, Input, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { Group } from 'src/app/users/interfaces/group';
import { BreakpointObserver } from '@angular/cdk/layout';
import { QmAutocompleteData } from '@md2/md2-component-lib';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers:[
    MessageService
  ]
})
export class HeaderComponent implements OnInit {
  versionApp: string = '';
  items: MenuItem[] = [];
  itemsmenu: QmAutocompleteData[] = [];
  listaSuggestions: QmAutocompleteData[] = [];
  moduleValue!: string;
  groupUser!: Group;
  mobileLayout: boolean = false;

  @Input()
  display: boolean = false;

  constructor(
    private authService: AuthService,
    private headerService: HeaderService,
    private messageService: MessageService,
    private router: Router,
    private bkObs: BreakpointObserver
  ) {

  }

  ngOnInit() {
    this.genereatedMenu();

    this.bkObs.observe(`(max-width: 768px)`)
    .subscribe(state => {
        this.mobileLayout = state.matches;
        this.display = false;
    })
    
  }

  genereatedMenu() {
    const roles: string[] = this.authService.role.replace(/^\[|\]$/g, '').split(',').map((s: string) => s.trim());

    this.items = [
      {
        label: 'Módulos',
        icon: 'pi pi-sitemap',
        items: [
          {
            label: 'Controle de acesso', icon: 'pi pi-user-edit',
            visible: (roles.includes('admin') || roles.includes('admin')),
            items: [
              {
                label: 'Usuários', icon: 'pi pi-users', routerLink: 'users/user',
                visible: (roles.includes('admin') || roles.includes('admin'))
              },
              {
                label: 'Grupos', icon: 'pi pi-book', routerLink: 'users/group',
                visible: (roles.includes('admin') || roles.includes('admin'))
              },
              {
                label: 'Configuração LDAP', icon: 'pi pi-user-edit', routerLink: 'ldapConfig',
                visible: (roles.includes('admin'))
              }
            ]
          },
          {
            label: 'Configuração', icon: 'pi pi-user-edit', visible: (roles.includes('admin')),
            items: [
              { label: 'Configuração AI', icon: 'pi pi-user-edit', routerLink: 'setup', visible: (roles.includes('admin')) }
            ]
          },
          { label: 'Modelos', icon: 'pi pi-book', routerLink: 'model', visible: (roles.includes('admin')) },
          {
            label: 'Rastreamento de prontuário', icon: 'pi pi-book',
            items: [
              { label: 'Categoria dos itens de prontuário', icon: 'pi pi-book', routerLink: 'assunto', visible: true },
              { label: 'Itens de prontuário', icon: 'pi pi-book', routerLink: 'subfaturamento', visible: true },
              { label: 'Hierarquia de itens', icon: 'pi pi-book', routerLink: 'subfaturamento-fluxograma', visible: true }
            ]
          },
          {
            label: 'Regras de validação', icon: 'pi pi-book',
            items: [
              { label: 'Tipos de Regras', icon: 'pi pi-book', routerLink: 'tipoRegraValidacao', visible: true },
              { label: 'Regras', icon: 'pi pi-book', routerLink: 'regraValidacao', visible: true },
              { label: 'Associação de Regras', icon: 'pi pi-book', routerLink: 'associacaoRegraUnidadeSistema', visible: true },
              { label: 'Hierarquia de Regras', icon: 'pi pi-book', routerLink: 'fluxograma', visible: true },
              { label: 'Relatorios de Regras', icon: 'pi pi-book', routerLink: 'relatorio', visible: true }
            ]
          },
          {
            label: 'Central de notificação', icon: 'pi pi-book',
            items: [
              { label: 'Grupo', icon: 'pi pi-book', routerLink: 'grupoEmail', visible: true },
              { label: 'Pessoa', icon: 'pi pi-book', routerLink: 'pessoaEmail', visible: true },
              { label: 'Ações Automatizadas', icon: 'pi pi-book', routerLink: 'acoesAutomatizadas', visible: true }
            ]
          }

        ]
      }
    ];

    var menuListFlat = this.flatMenuStructure(JSON.parse(JSON.stringify(this.items)));

    for (const item of menuListFlat) {
      if (item.routerLink !== undefined) {
        this.itemsmenu.push({ label: item.label ?? 'Item', value: { url: item.routerLink, visible: item.visible } })
      }
    }

    this.headerService.getVersionApp().subscribe ({
      next: (data) => this.versionApp = data,
      error: (err) => {
        this.messageService.add({severity:'error', summary:'Falha', detail: err.error.error})
      }
    });
  }

  onSearchData(event: any): void {
    this.listaSuggestions = this.itemsmenu.filter(el => el.label?.trim().toLowerCase().indexOf(event.query?.trim().toLowerCase()) !== -1);
  }

  onSelectData(event: any) {
    this.router.navigate([event.value.url]);
  }

  flatMenuStructure(itemTree: MenuItem[]): MenuItem[] {
    let items: MenuItem[] = [];
    const flattenMembers = itemTree.map(m => {
      if (m.items && m.items.length) {
        items = [...items, ...m.items];
      }
      return m;
    });

    return flattenMembers.concat(items.length ? this.flatMenuStructure(items) : items);
  };

  logout() {
    this.authService.logout();
  }
}
